import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.css']
})
export class MessageListComponent extends BaseListCtl {

  datePickerConfig : Partial<BsDatepickerConfig>;

  constructor(public locator: ServiceLocatorService, private http: HttpClient, public route: ActivatedRoute) { 
    super(locator.endpoints.MESSAGE,locator,route);

    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: true,
        
        maxDate: new Date(),
        dateInputFormat: 'DD/MM/YYYY'
      });
  }

  populateForm(form, data) {
    form.id = data.id;
    form.mobile=data.mobile;
    form.userId=data.userId;
    form.userName=data.userName;
    form.dateTime=data.dateTime;
    form.endTime = data.endTime;
    form.mobileId=data.mobileId;
    form.message=data.message;
    form.type=data.type;
    console.log('----->',data);
  }
}
